import { Box, Button, Fade, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { Url } from "../Api/Api";
import { toast, ToastContainer } from "react-toastify";
import ProfileChangeNewPassword from "./ProfileChangeNewPassword";

const ProfileOTPVarificationPage = (props) => {
  let {
    handleResendOTP,
    handleSubmit,
    email,
    setTimeLeft,
    timeLeft,
    otp,
    setOtp,
    setForgotPasswordOpen,
    isStudent,
  } = props;
  const inputRefs = useRef([]);

  // const [otp, setOtp] = useState(Array(6).fill(""));
  // const [timeLeft, setTimeLeft] = useState(60);

  const FlatOTP = otp.join("");

  const [isOTPLoading, setIsOTPLoading] = useState(false);
  const [changeNewPassword, setChangeNewPassword] = useState(false);

  const handleChange = (value, index) => {
    if (/^\d$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Move to the next input field
      if (index < otp.length - 1) {
        inputRefs.current[index + 1]?.focus();
      }
    } else if (value === "") {
      const newOtp = [...otp];
      newOtp[index] = "";
      setOtp(newOtp);
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && otp[index] === "") {
      if (index > 0) {
        inputRefs.current[index - 1]?.focus();
      }
    }
  };

  const formatTime = () => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  };

  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setInterval(() => {
        setTimeLeft((prev) => prev - 1);
      }, 1000);
      return () => clearInterval(timer); // Cleanup interval on unmount
    }
  }, [timeLeft]);

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").slice(0, 6); // Limit to 4 digits
    if (/^\d{1,4}$/.test(pastedData)) {
      const newOtp = pastedData
        .split("")
        .concat(Array(6 - pastedData.length).fill(""));
      setOtp(newOtp);

      // Automatically move focus to the last filled field
      const nextIndex = Math.min(newOtp.length - 1, 3);
      inputRefs.current[nextIndex]?.focus();
    }
  };

  const handleSubmitOTP = async () => {
    const input = {
      ...(isStudent
        ? { studentEmail: String(email), otp: String(FlatOTP) }
        : { emailId: String(email), otp: String(FlatOTP) }),
    };

    const UserUrl = isStudent ? Url.StudentResetPassword : Url.ResetPassword;

    try {
      setIsOTPLoading(true);
      const response = await axios.post(UserUrl, input);

      if (response?.data?.status === "1") {
        toast.success(response?.data?.message, {
          onClose: () => setChangeNewPassword(true), 
        });
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      toast.error("Network error. Please try again later.");
    } finally {
      setIsOTPLoading(false);
    }
  };

  return (
    <>
      {changeNewPassword ? (
        <ProfileChangeNewPassword
          email={email}
          setForgotPasswordOpen={setForgotPasswordOpen}
          isStudent={isStudent}
        />
      ) : (
        <Fade in={true} timeout={800}>
          <Box
            sx={{
              width: { xs: "100%", sm: "450px" },
              // p: { xs: 3, sm: 5 },
            }}
          >
            <Box sx={{ mb: 4, mt: 2 }}>
              <Typography
                variant="body1"
                sx={{
                  color: "text.secondary",
                  fontSize: { xs: "0.9rem", sm: "1rem" },
                }}
              >
                Please enter six digit OTP sent to your Email
              </Typography>
            </Box>
            <Typography
              variant="body1"
              sx={{
                color: "text.secondary",
                fontSize: { xs: "0.9rem", sm: "0.8rem" },
              }}
            >
              Enter OTP Code
            </Typography>
            {/* OTP Input Boxes */}
            <Grid
              sx={{ display: "flex", gap: "10px", mt: 1 }}
              onPaste={handlePaste}
            >
              {otp.map((digit, index) => (
                <input
                  key={index}
                  autoFocus={index === 0}
                  type="text"
                  value={digit}
                  maxLength="1"
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  ref={(el) => (inputRefs.current[index] = el)}
                  style={{
                    width: "60px",
                    height: "60px",
                    textAlign: "center",
                    fontSize: "18px",
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                  }}
                />
              ))}
            </Grid>
            <Stack
              spacing={2}
              direction={"row"}
              justifyContent={"space-between"}
              alignItems="center"
              mt={2}
            >
              {/* Cancel Button */}
              <Button
                variant="outlined"
                sx={{
                  padding: { xs: "6px 23px", sm: "10px 39px" },
                  height: { xs: 35, sm: 41 },
                  fontSize: { xs: "12px", sm: "15px" },
                  color: "#666666",
                  fontWeight: 400,
                  border: "1px solid rgba(17, 35, 71, 0.1)",
                  borderRadius: "5px",
                  textTransform: "none",
                }}
                onClick={() => setForgotPasswordOpen(false)}
              >
                Cancel
              </Button>

              {/* Timer */}
              {timeLeft > 0 && (
                <Typography sx={{ color: "black" }}>
                  Time left:&nbsp;
                  <span
                    style={{
                      color: timeLeft <= 20 ? "#D42F2F" : "black",
                      fontWeight: 600,
                    }}
                  >
                    {formatTime()}
                  </span>
                </Typography>
              )}

              {/* Actions */}
              <Stack direction="row" spacing={3} alignItems="center">
                {otp.every((digit) => digit) && timeLeft > 0 && (
                  <Button
                    variant="contained"
                    onClick={handleSubmitOTP}
                    disabled={isOTPLoading}
                    sx={{
                      background: "#4CA4D6",
                      "&:hover": { background: "#3b92be" },
                      textTransform: "none",
                    }}
                  >
                    {isOTPLoading ? "Verifying..." : "Submit OTP"}
                  </Button>
                )}

                {timeLeft === 0 && (
                  <Typography
                    onClick={() => {
                      handleResendOTP();
                      handleSubmit();
                    }}
                    sx={{
                      cursor: "pointer",
                      color: "#D42F2F",
                      fontWeight: 500,
                      fontSize: "14px",
                    }}
                  >
                    Resend OTP
                  </Typography>
                )}
              </Stack>

              {/* Toast */}
              <ToastContainer
                position="top-right"
                autoClose={1500}
                theme="light"
              />
            </Stack>
          </Box>
        </Fade>
      )}
    </>
  );
};

export default ProfileOTPVarificationPage;
